import type { Motivation } from '../types/content'

export const motivations: Motivation[] = [
  {
    id: 'detente',
    label: 'Pour se détendre',
    title: 'Accordez-vous une pause créative',
    description:
      'Choisissez un motif, préparez vos couleurs et profitez du plaisir de créer quelque chose de vos mains.',
    benefits: [
      'Un moment loin des écrans',
      'Une activité à votre rythme',
      'Une décoration qui vous ressemble',
    ],
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/26fe5a67-461e-4634-a986-a185f9a59b49.jpg',
    imageAlt:
      'Mains peignant une branche de feuilles en faux vitrail sur un support transparent, à côté d’une tasse de thé',
  },
  {
    id: 'offrir',
    label: 'Pour offrir',
    title: 'Créez un cadeau personnel',
    description:
      'Choisissez les formes et les couleurs qui évoquent la personne à qui vous souhaitez offrir votre création.',
    benefits: [
      'Des couleurs choisies avec attention',
      'Une pièce réalisée à la main',
      'Le plaisir d’offrir votre propre création',
    ],
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/6c8fb521-7948-474d-b1b5-c9cf0a01f102.jpg',
    imageAlt:
      'Petite plaque en faux vitrail posée dans une boîte cadeau en kraft avec un ruban de lin',
  },
  {
    id: 'vendre',
    label: 'Pour vendre',
    title: 'Explorez aussi la création de pièces à proposer',
    description:
      'Si vous souhaitez aller plus loin, vous pouvez envisager une petite collection de pièces décoratives. Le prix dépendra notamment du support, du temps de réalisation et de la finition.',
    benefits: [
      'Imaginer une collection cohérente',
      'Soigner la présentation de vos pièces',
      'Évaluer vos coûts avant de fixer un prix',
    ],
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/ff773ed5-f9ae-4615-8f12-4366f8c0e9e6.jpg',
    imageAlt:
      'Quatre pièces en faux vitrail peint sur une table en bois : un photophore, un vase fleuri, un cadre floral et un miroir décoré',
    note: 'Le pack enseigne la technique créative ; il ne comprend pas de formation à la vente.',
    priceTagsTitle: 'Idées de créations à proposer',
    priceTags: [
      { label: 'Petit photophore', amount: 12, position: 'top-left' },
      { label: 'Vase fleuri', amount: 24, position: 'top-right' },
      { label: 'Cadre floral', amount: 29, position: 'bottom-left' },
      { label: 'Miroir décoré', amount: 39, position: 'bottom-right' },
    ],
  },
]
